import React from "react";
import About from "./About/About";

const AboutPage = () => {
  return <About />;
};

export default AboutPage;
